module.exports = __webpack_public_path__ + "img/renwu2.d64bd7eb.png";